module.exports = __webpack_public_path__ + "assets/img/7.26292541.jpg";